import { BasePreferences } from '@base/features/preferences/model/types';

export interface Preferences extends BasePreferences {
  AUTO_ROLL: boolean;
  AUTO_CONFIRM: boolean;
  MY_HOME_IS_ON_LEFT: boolean;
  BOARD: string;
  DOUBLE_CUBE: boolean;
}

const DEFAULT_PREFERENCES: Preferences = {
  THEME: 't-green',
  FONT_SIZE: 16,
  SOUND_ALL_MUTE: false,
  SOUND_ON_YOUR_MOVE: true,
  SOUND_ON_OPPONENT_MOVE: true,
  SOUND_ON_JOINING_YOUR_TABLE: true,
  SOUND_ON_INVITATION: true,
  DISALLOW_CHAT_WHILE_PLAYING: false,
  DOUBLE_CLICK_MOVE: true,
  AUTO_ROLL: false,
  AUTO_CONFIRM: false,
  MY_HOME_IS_ON_LEFT: false,
  BOARD: 'classic',
  DOUBLE_CUBE: false,
};

export default DEFAULT_PREFERENCES;
